export default __webpack_public_path__ + "static/media/jeff-sheldon.acb37a41.jpg";